var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4187 16.1073C31.862 16.729 32.0837 17.0399 32.0837 17.5C32.0837 17.9601 31.862 18.271 31.4187 18.8927C29.4264 21.6863 24.3387 27.7083 17.5003 27.7083C10.6619 27.7083 5.57422 21.6863 3.58205 18.8927C3.13867 18.271 2.91699 17.9601 2.91699 17.5C2.91699 17.0399 3.13867 16.729 3.58205 16.1073C5.57422 13.3138 10.6619 7.29166 17.5003 7.29166C24.3387 7.29166 29.4264 13.3138 31.4187 16.1073Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 17.5C21.875 15.0837 19.9163 13.125 17.5 13.125C15.0837 13.125 13.125 15.0837 13.125 17.5C13.125 19.9163 15.0837 21.875 17.5 21.875C19.9163 21.875 21.875 19.9163 21.875 17.5Z",
    stroke: "white",
    strokeWidth: 1.5625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVisible);
export default __webpack_public_path__ + "static/media/ProfileVisible.5983c06387f64d97004c1aed0fa4e5df.svg";
export { ForwardRef as ReactComponent };